<template>
  <div>
    <el-button type="text" @click="dialogVis= true">{{title}}</el-button>
    <el-dialog :title="title" :before-close="handleClose" :visible.sync="dialogVis" width="500px">
      <el-form ref="phoneForm" :model="formData" label-width="100px" size="mini" :rules="rules">
        <el-form-item v-if="title!=='绑定手机号'" label="原手机号">
          <p>{{formData.phone | numEncry}}</p>
        </el-form-item>
        <div class="dd">
          <el-form-item label="新手机号" prop="newPhone">
            <el-select class="short" v-model="formData.area">
              <el-option label="+86(中国)" value></el-option>
            </el-select>
            <el-input class="marLeft10" v-model="formData.newPhone" placeholder="新手机号"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="verification">
            <el-input v-model="formData.verification" placeholder="验证码"></el-input>
            <el-button
              @click="handleSendCode"
              type="primary"
              :disabled="!show"
              style="margin-left:10px;"
            >
              <span v-show="show">获取验证码</span>
              <span v-show="!show">{{count}} s</span>
            </el-button>
          </el-form-item>
          <div class="footer">
            <el-button size="mini" type="primary" @click="handleSubmit">绑定</el-button>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "bind-modify-phone",
  props: {
    title: String,
    phone: String
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("电话号码不能为空"));
      } else if (value.length !== 11) {
        callback(new Error("请检查电话号码格式"));
      } else if (value === this.formData.phone) {
        callback(new Error("新手机号不能与原先手机号相同"));
      } else {
        callback();
      }
    };
    return {
      formData: {
        area: "",
        newPhone: "",
        verification: "",
        phone: ""
      },
      show: true,
      count: "",
      timer: null,
      btnMes: "发送验证码",
      dialogVis: false,
      rules: {
        newPhone: [
          {
            required: true,
            validator: checkPhone
          }
        ],
        verification: [
          {
            required: true,
            message: "验证码不能为空"
          }
        ]
      }
    };
  },
  watch: {
    phone: {
      handler: function(phone) {
        this.formData.phone = phone;
      }
    }
  },
  filters: {
    numEncry(val) {
      return val.substr(0, 3) + "****" + val.substr(7);
    }
  },
  destroyed() {
    this.show = true;
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    handleClose() {
      // this.formData= {
      //   area: '',
      //   newPhone: '',
      //   verification: '',
      //   phone: this.formData.phone
      // }
      this.$refs["phoneForm"].resetFields();
      this.formData.phone = this.phone;
      this.dialogVis = false;
      this.show = true;
      clearInterval(this.timer);
      this.timer = null;
    },
    handleSubmit() {
      // ajax请求校验
      this.$refs["phoneForm"].validate(validate => {
        if (validate) {
          this.checkCodeByPhone();
        } else {
          return false;
        }
      });
    },
    async checkCodeByPhone() {
      const {
        ret,
        data: { message, result, passportId }
      } = await _api.customer.checkCodeByPhone({
        phone: this.formData.newPhone,
        code: this.formData.verification
      });
      if (ret && result === true) {
        this.formData.phone = this.formData.newPhone;
        this.dialogVis = false;
        this.$emit("update:phone", this.formData.newPhone);
      } else {
        this.$message(message);
      }
    },
    async handleSendCode() {
      if (this.formData.newPhone === "") {
        this.$message({
          type: "error",
          message: "请填写手机号后发送"
        });
        return;
      }
      const {
        ret,
        data: { message }
      } = await _api.customer.sendPhoneCode({
        phone: this.formData.newPhone
      });
      if (ret && message) {
        this.$message({
          type: "success",
          message: message
        });
        this.DealaySendCode();
      }
    },
    DealaySendCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    }
  }
};
</script>
<style scoped>
.el-input {
  width: 150px;
}
.el-select {
  width: 150px;
}
.marLeft10 {
  margin-left: 10px;
}
</style>
